import React, { useState } from 'react'
import { Flex, Heading } from '@pancakeswap/uikit'
import LockV2Card from './components/LockCard/v2'
import LockCards from './components/LockCards'
import useLockList from './hooks/v2/useLockList'
import useLockConfig from './hooks/v2/useLockConfig'

const AllV2Locks = () => {
  const [status, setStatus] = useState(false)
  const { lockList } = useLockList(status)
  const lockConfig = useLockConfig()

  const toggleStatus = () => {
    setStatus(!status)
  }

  return (
    <LockCards isSingle={lockList.length === 0}>
      {
        lockList.length === 0 ? (
          <Flex justifyContent='center' mt='24px'>
            <Heading scale='lg'>You do not have Lock.</Heading>
          </Flex>
        ) : (lockList.map((lockData) => (
          <LockV2Card
            key={lockData.id}
            config={lockConfig}
            data={lockData}
            onUnlocked={toggleStatus} />
        )))
      }
    </LockCards>
  )
}

export default AllV2Locks
